import * as React from 'react';
import { useSelector } from 'react-redux';

import { SalesLinks } from '../../components/SalesLinks';
import { getSalesLinks } from '../../selectors/mainpage';
import { ISalesLink } from '../../types/salesLink';
import { trackSalesLinkClick } from './tracking';

interface ISalesLinksContainerProps {
  section: string;
}

export function SalesLinksContainer({ section }: ISalesLinksContainerProps) {
  const salesLinks = useSelector(getSalesLinks);

  const handleLinkClick = React.useCallback((link: ISalesLink) => {
    trackSalesLinkClick(link.salesType);
  }, []);

  if (!salesLinks.length || section !== 'new-buildings') {
    return null;
  }

  return <SalesLinks links={salesLinks} onLinkClick={handleLinkClick} />;
}
